import { type InfiniteData } from '@tanstack/react-query';

import { type IAdfoxSchema } from '@/repositories/generated/shared/search-offers/entities/adfox/AdfoxSchema';
import { type ISortOptionSchema } from '@/repositories/generated/shared/search-offers/entities/sorting_properties/SortOptionSchema';
import type { TSearchOffersDesktopResponse_1 } from '@/repositories/generated/shared/search-offers/v3/search-offers-desktop';

export function adfoxFromGetOffersSelector(state: TSearchOffersDesktopResponse_1): IAdfoxSchema {
  return state.adfox;
}

export function sortOptionsFromGetOffersSelector(state: TSearchOffersDesktopResponse_1): ISortOptionSchema[] {
  return state.sortingProperties.sortOptions;
}

export function flatInfinityOffersSelector(
  data: InfiniteData<TSearchOffersDesktopResponse_1>,
): InfiniteData<TSearchOffersDesktopResponse_1> {
  const firstPage = data.pages[0];
  const lastPage = data.pages[data.pages.length - 1];

  return {
    pages: [
      {
        offers: data.pages.flatMap(page => page.offers),
        seo: {
          view: firstPage.seo.view,
          tech: lastPage.seo.tech,
        },
        breadcrumbs: firstPage.breadcrumbs,
        similarOffers: firstPage.similarOffers,
        sortingProperties: firstPage.sortingProperties,
        adfox: lastPage.adfox,
        analytics: lastPage.analytics,
        listingProperties: lastPage.listingProperties,
      },
    ],
    pageParams: data.pageParams,
  };
}
